import { createClient } from '@supabase/supabase-js'

// 👇 Reemplazá con tus datos reales
const supabaseUrl = 'https://yvcbbjynplivkgematft.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl2Y2JianlucGxpdmtnZW1hdGZ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxNTAyODksImV4cCI6MjA3MTcyNjI4OX0.pBKLC65ysynaiFh62NqdOzajz2bRVDwCXBDuGHGBV6c'

// Cliente para operaciones normales (anon key)
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Cliente para operaciones de admin (service role key)
// ⚠️ IMPORTANTE: Necesitas agregar tu Service Role Key aquí
// Ve a tu dashboard de Supabase -> Settings -> API -> service_role key
// Reemplaza 'TU_SERVICE_ROLE_KEY_AQUI' con tu clave real
const supabaseServiceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl2Y2JianlucGxpdmtnZW1hdGZ0Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc1NjE1MDI4OSwiZXhwIjoyMDcxNzI2Mjg5fQ.mQ6PDtJITDrKXsfTdBf3BGUpVAxntSnOHjQE5ii7VpQ' // 👈 Reemplaza con tu Service Role Key

export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey)